module.exports = __webpack_public_path__ + "static/media/iStock-872191096.3fc5c212.jpg";